import { ConnectivityState, PingKind } from "@eisox/api/core-api";
import type { BadgeProps } from "@eisox/design-system";
import { colors } from "@eisox/tokens";

import { m } from "~/paraglide/messages";

import { ConnectivityHistoryTab } from "./types/connectivity-history.type";

const CONNECTIVITY_HISTORY_MAX_DAYS = 31;

const CONNECTIVITY_HISTORY_DEFAULT_DAYS = 7;

const CONNECTIVITY_HISTORY_TABS: Record<ConnectivityHistoryTab, { label: () => string; subtitle: () => string }> = {
  [ConnectivityHistoryTab.AVAILABILITY]: {
    label: m.connectivity_history_tab_availability,
    subtitle: m.connectivity_history_availability_subtitle,
  },
  [ConnectivityHistoryTab.MESSAGES]: {
    label: m.connectivity_history_tab_messages,
    subtitle: m.connectivity_history_messages_subtitle,
  },
};

const CONNECTIVITY_STATES: Record<
  ConnectivityState,
  { label: () => string; color: string; badge: NonNullable<BadgeProps["status"]> }
> = {
  [ConnectivityState.CONNECTED]: {
    label: m.connectivity_state_connected,
    color: colors.chart.blue,
    badge: "success",
  },
  [ConnectivityState.DEGRADED]: {
    label: m.connectivity_state_degraded,
    color: colors.primary.orange,
    badge: "warning",
  },
  [ConnectivityState.DISCONNECTED]: {
    label: m.connectivity_state_disconnected,
    color: colors.primary.red,
    badge: "error",
  },
  [ConnectivityState.NO_DATA]: {
    label: m.connectivity_state_no_data,
    color: colors.primary.darkerGray,
    badge: "warning",
  },
};

const PING_KINDS: Record<PingKind, { label: () => string; color: string }> = {
  [PingKind.FIRST]: { label: m.connectivity_ping_first, color: colors.primary.darkGray },
  [PingKind.EARLY]: { label: m.connectivity_ping_early, color: colors.primary.darkBlue },
  [PingKind.REGULAR]: { label: m.connectivity_ping_regular, color: colors.chart.blue },
  [PingKind.LATE]: { label: m.connectivity_ping_late, color: colors.primary.orange },
  [PingKind.RECONNECTED]: { label: m.connectivity_ping_reconnected, color: colors.primary.red },
};

export {
  CONNECTIVITY_HISTORY_DEFAULT_DAYS,
  CONNECTIVITY_HISTORY_MAX_DAYS,
  CONNECTIVITY_HISTORY_TABS,
  CONNECTIVITY_STATES,
  PING_KINDS,
};
